<template>
    <div class="bg-gray-800 shadow-lg rounded-lg">
        <div class="text-gray-50 px-4 py-2 text-sm font-semibold">
            {{ label }}

            <div class="float-right">
                <!-- <Icon v-if="copied" name="material-symbols:check-small-rounded" class="text-bold text-xl text-green-500" title="Copied!" />
                <span v-if="copied" class="text-green-500 mr-4">Copied!</span> -->

                <!-- <button @click="download" title="Download code" class="mr-4">
                    <Icon name="material-symbols:download" class="text-bold text-lg hover:text-green-500" />
                </button> -->
                <button @click="copy()" title="Copy code">
                    <Icon name="material-symbols:content-copy-outline-rounded"
                        class="text-bold text-lg hover:text-green-500" />
                </button>
            </div>
        </div>

        <div class="m-0 p-0 border border-gray-500" />
        <div class="text-xs font-mono px-4 py-2 text-green-300 overflow-x-auto">
            <pre class="w-full whitespace-pre max-h-72">{{ code }}</pre>
        </div>
    </div>
</template>

<script lang="ts">

export default {
    props: {
        code: {
            type: String,
            required: true,
        },
        label: String,
        page: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            // copied: false,
        };
    },
    methods: {
        // download() {
        //     var element = document.createElement('a');
        //     element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.code));
        //     element.setAttribute('download', this.label || '_file.ts');

        //     element.style.display = 'none';
        //     document.body.appendChild(element);

        //     element.click();

        //     document.body.removeChild(element);
        // },
        copy() {
            this.copyText();

            // setTimeout(() => {
            //     this.copied = false;
            // }, 2000);
        },

        copyText() {
            if (!navigator?.clipboard?.writeText) {
                return;
            }

            navigator.clipboard?.writeText(this.code || '').then(() => {

            });
        },
    },
};
</script>